import { Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import PayperviewCategoryskeleton from "components/skeleton/PayperviewCategoryskeleton";
import { lazy, Suspense } from "react";

const PayPerViewCategoryCard = lazy(() => import("./PayPerViewCategoryCard"));

const PayPerViewCategoryCarousal = ({ categories, isLoading }: any) => {
  return (
    <>
      {!isLoading && (
        <Suspense fallback={<PayperviewCategoryskeleton />}>
          <div>
            {categories && (
              <>
                {/* coursel */}
                <div className="">
                  <Swiper
                    slidesPerView={5}
                    breakpoints={{
                      0: {
                        slidesPerView: 1,
                      },
                      350: {
                        slidesPerView: 2,
                      },
                      550: {
                        slidesPerView: 4,
                      },
                      1000: {
                        slidesPerView: 4,
                      },
                      1100: {
                        slidesPerView: 5,
                      },
                      1200: {
                        slidesPerView: 6,
                      },
                      1400: {
                        slidesPerView: 7,
                      },
                    }}
                    modules={[Pagination]}
                    className="mt-4 mb-5 mySwiper"
                  >
                    {categories.map((category: any, i: number) => (
                      <SwiperSlide className="" key={i}>
                        <PayPerViewCategoryCard category={category} />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </>
            )}
          </div>
        </Suspense>
      )}
      {isLoading && <PayperviewCategoryskeleton />}
    </>
  );
};

export default PayPerViewCategoryCarousal;
